import { useParams, Link } from "react-router-dom";
import { ChevronLeft, ShieldCheck } from "lucide-react";
import MultiStepForm from "@/components/shared/MultiStepForm";
import { useLang } from "@/lib/i18n";
import { Seo } from "@/lib/seo";

export default function Anfrage() {
  const { type } = useParams();
  const { t } = useLang();

  return (
    <div className="bg-[#F6F7F8]">
      <Seo
        title={t("Anfrage stellen \u2013 kostenfrei & unverbindlich", "Submit Inquiry \u2013 Free & Non-Binding")}
        description={t(
          "Stellen Sie Ihre Anfrage an die II Eleven Gruppe in wenigen Schritten \u2013 DSGVO-konform, dokumentiert und mit pers\u00f6nlicher R\u00fcckmeldung innerhalb eines Werktages.",
          "Submit your inquiry to the II Eleven Group in a few steps \u2013 GDPR-compliant, documented and with a personal response within one business day."
        )}
      />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-[#6B7280] hover:text-[#111318] transition-colors" data-testid="anfrage-back-link">
          <ChevronLeft className="h-4 w-4" /> {t("Zur\u00fcck zur Startseite", "Back to home")}
        </Link>
        <div className="mt-6 grid grid-cols-1 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-3">
            <MultiStepForm formType={type} />
          </div>
          <aside className="lg:col-span-2">
            <div className="lg:sticky lg:top-28 space-y-5">
              <div className="rounded-[8px] bg-white border border-border p-7">
                <h3 className="font-display text-lg font-semibold text-[#111318]">{t("So geht es weiter", "What happens next")}</h3>
                <ol className="mt-5 space-y-5 text-sm text-[#3B4452]">
                  {[
                    t("Ihre Anfrage wird strukturiert erfasst und einem pers\u00f6nlichen Ansprechpartner zugeordnet.", "Your request is structurally recorded and assigned to a personal contact."),
                    t("Wir melden uns in der Regel innerhalb eines Werktages bei Ihnen.", "We usually get back to you within one business day."),
                    t("Im Erstgespr\u00e4ch kl\u00e4ren wir Ihre Ziele \u2013 pers\u00f6nlich und unverbindlich.", "In the first meeting we clarify your goals \u2013 personally and without obligation."),
                  ].map((s, i) => (
                    <li key={i} className="flex gap-3.5">
                      <span className="font-mono-num text-xs font-semibold text-[#E8241B] mt-0.5">0{i + 1}</span>
                      <span className="leading-relaxed">{s}</span>
                    </li>
                  ))}
                </ol>
              </div>
              <div className="rounded-[8px] bg-white border border-border p-6 flex items-start gap-3">
                <ShieldCheck className="h-4 w-4 text-[#E8241B] shrink-0 mt-0.5" />
                <p className="text-xs text-[#3B4452] leading-relaxed">
                  {t(
                    "DSGVO-konforme Verarbeitung: Einwilligungen werden dokumentiert und sind jederzeit widerrufbar. Ihre Anfrage stellt kein Angebot dar.",
                    "GDPR-compliant processing: consents are documented and revocable at any time. Your inquiry does not constitute an offer."
                  )}
                </p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}
